var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgR18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 235.11 226.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        stroke-width: 1.99px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        opacity: 0;\n        stroke: #000;\n        stroke-miterlimit: 1;\n      }\n\n      .cls-3 {\n        stroke-width: .8px;\n      }\n\n      .cls-4 {\n        stroke-width: .79px;\n      }\n\n      .cls-6 {\n        mix-blend-mode: overlay;\n        opacity: .49;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: #f9f9f9;\n        fill-rule: evenodd;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.46,43.95c-35.02,39.39-31.59,99.85,7.67,135.03,39.27,35.17,99.49,31.75,134.52-7.64,35.02-39.4,31.59-99.86-7.67-135.03-18.17-16.28-40.85-24.3-63.43-24.3-26.19,0-52.27,10.78-71.09,31.93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2308.01,
    y1: -4711.51,
    x2: -2308.01,
    y2: -4902.77,
    gradientTransform: "translate(-2190.46 -4699.49) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99dfcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#77b2e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9cace7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1a7e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "newer"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 111.62,
    cy: 126.14,
    r: 88.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 5.88,
    y: 6.16,
    width: 223.35,
    height: 213.85,
    transform: "translate(-6.22 6.85) rotate(-3.25)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.46,43.95c-35.03,39.39-31.59,99.85,7.67,135.03,39.27,35.17,99.49,31.75,134.52-7.64,35.02-39.4,31.59-99.86-7.67-135.03C141.72,1.14,81.5,4.56,46.46,43.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.76,46.9c-33.6,37.79-30.3,95.77,7.35,129.51,37.66,33.74,95.4,30.46,129-7.32,33.58-37.79,30.29-95.77-7.36-129.51C141.1,5.83,83.36,9.11,49.76,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.76,46.9c-33.6,37.79-30.3,95.77,7.35,129.51,37.66,33.74,95.4,30.46,129-7.32,33.58-37.79,30.29-95.77-7.36-129.51C141.1,5.83,83.36,9.11,49.76,46.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.93,54.36c-29.38,33.07-26.5,83.81,6.43,113.34,32.94,29.52,83.44,26.66,112.83-6.41,29.37-33.07,26.49-83.81-6.43-113.34-32.94-29.52-83.44-26.66-112.83,6.41"
  }), /*#__PURE__*/React.createElement("image", {
    width: 2124,
    height: 1756,
    transform: "translate(51.87 51.89) scale(.06)",
    xlinkHref: "F:\\\\\\\\Onboarding Guide\\\\\\\\Web\\\\\\\\Onboarding Guide_FINAL_web Folder\\\\\\\\Links\\\\\\\\ESC18-Black-Apple-No-Tag-Vertical (1).png"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR18);
export default __webpack_public_path__ + "static/media/R18.223a7ef929875390729e5f8c01a346bc.svg";
export { ForwardRef as ReactComponent };